import { createTheme } from '@mui/material/styles';
export const palette = {
  primary: {
    main: '#710FEA',
    onPrimary: '#FFFFFF',
    faint: '#EDE5FD',
    outline: '#D4BBFB',
    deep: '#5A0FBB',
  },
  primaryContainer: {
    main: '#E3CFFC',
    onPrimary: '#450990',
  },
  secondary: {
    main: '#A4F4EC',
    onSecondary: '#062D29',
  },
  surfaceContainerLow: {
    main:'#F5F3F3'
  },
  surfaceContainerHigh: {
    main: '#EBE7E7',
  },
  surfaceContainerHighest: {
    main: '#E5E2E1'
  },
  tertiary: {
    main: '#D700E5',
    onTertiary: '#FFFFFF',
  },
  tertiaryContainer: {
    main: '#FDE5FF',
    onTertiary: '#600066',
  },
  onSurfaceVariant: {
    main: '#444748',
  },
  surface: {
    main: '#FCFCFC',
  },
  onSurface: {
    main: '#1D1B20',
  },
  onSurfaceTransparent: {
    main: 'rgba(29, 27, 32, 0.08)'
  },
  outline: {
    main: '#747878',
  },
  outLineVariant: {
    main: '#C4C7C7',
  },
  background: {
    main: '#E3CFFC',
  },
  info: {
    main: '#710FEA',
  },
  success: {
    main: '#64D916',
  },
  warning: {
    main: '#F9D2D3',
  },
  blueJeans: {
    main: '#37ACFF',
    onBlueJeans: '#004475',
  },
  sheenGreen: {
    main: '#64D916',
    onSheenGreen: '#265208',
  },
  goldenPoppy: {
    main: '#FFC300',
    onGoldenPoppy: '#806200',
  },
  error: {
    main: '#E4252E',
    onError: '#FFFFFF',
  },
  errorContainer: {
    main: '#F9D2D3',
    onError: '#2D0607',
  },
  text: {
    main: '#1D1B20',
    secondary: '#444748', // On surface variant
  },
  surfaceLow: {
    main: '#F5F3F3',
    onSurfaceLow: '#1D1B20',
  },
  surfaceHigh: {
    main: '#EBE7E7',
    onSurfaceHigh: '#1D1B20',
  },
  emerald: {
    main: '#22C55E',
    surface: '#F0FDF4',
    container: '#DCFCE7',
    onContainer: '#15803D',
    border: '#86EFAC',
  },
  amber: {
    main: '#F59E0B',
    surface: '#FFFBEB',
    container: '#FEF3C7',
    onContainer: '#B45309',
    border: '#FCD34D',
  },
  teal: {
    main: '#0F766E',
    surface: '#CCFBF1',
  },
  rose: {
    main: '#E11D48',
    surface: '#FFF1F2',
    onSurface: '#B91C1C',
    border: '#FECACA',
    hoverSurface: '#FEE2E2',
    hoverBorder: '#FCA5A5',
  },
  blue: {
    main: '#2563EB',
    surface: '#EFF6FF',
    container: '#DBEAFE',
    onContainer: '#1D4ED8',
    border: '#BFDBFE',
  },
  gray: {
    50: '#F9FAFB',
    100: '#F3F4F6',
    200: '#E5E7EB',
    300: '#D1D5DB',
    400: '#9CA3AF',
    500: '#6B7280',
    600: '#4B5563',
    700: '#374151',
    800: '#1F2937',
    900: '#111827',
  },
};
palette.tags = {
  open: {
    backgroundColor: palette.primary.main,
    color: palette.primary.onPrimary,
  },
  filled: {
    backgroundColor: palette.primaryContainer.main,
    color: palette.primaryContainer.onPrimary,
  },
  inProgress: {
    backgroundColor: palette.blueJeans.main,
    color: palette.blueJeans.onBlueJeans,
  },
  finished: {
    backgroundColor: palette.sheenGreen.main,
    color: palette.sheenGreen.onSheenGreen,
  },
  completed: {
    backgroundColor: palette.goldenPoppy.main,
    color: palette.goldenPoppy.onGoldenPoppy,
  },
  expired: {
    backgroundColor: palette.errorContainer.main,
    color: palette.errorContainer.onError,
  },
  cancelled: {
    backgroundColor: palette.tertiaryContainer.main,
    color: palette.tertiaryContainer.onTertiary,
  },
  quickcare:
  {
    backgroundColor: palette.primaryContainer.main,
    color: palette.primaryContainer.onSecondary,
  },
  unavailableToWork: {
    backgroundColor: palette.tertiaryContainer.main,
    color: palette.tertiaryContainer.onTertiary,
  },
  availableToWork: {
    backgroundColor: palette.tertiary.main,
    color: palette.tertiary.onTertiary,
  },
}

/**
 * QC-2867 — Support Email design tokens. Purely additive: no existing palette
 * key changes value, and no component styleOverrides are registered, so pages
 * that do not read `palette.qc` render exactly as before.
 *
 * ink   4-level text ramp (1 titles → 4 decorative-only, never load-bearing)
 * family  the three intent families: data (reads the educator's account),
 *         kb (knowledge base only), route (agent can't action — forwarded)
 */
palette.qc = {
  ink: { 1: '#23262A', 2: '#4A4F55', 3: '#71777D', 4: '#A0A6AC' },
  line: { main: '#E7E9EC', soft: '#F1F2F4' },
  surface: { 0: '#FFFFFF', 1: '#FAFAFB', 2: '#F4F5F7' },
  brand: { soft: '#F7F2FE', line: '#E4D6FB' },
  ok: { main: '#2F7D52', soft: '#F1F8F3', line: '#CBE3D4' },
  warn: { main: '#8A5A00', soft: '#FFF7E8', line: '#EBD9B4' },
  danger: { main: '#B3261E', soft: '#FDF3F2' },
  family: { data: '#5B8C7B', kb: '#6B84A8', route: '#A88A5B' },
  radius: { xs: 5, sm: 6, md: 8, lg: 12 },
  focusRing: '0 0 0 3px rgba(113, 15, 234, 0.07)',
}

const MuiPickersDay = {
  styleOverrides: {
    today: {
      backgroundColor: palette.primary.main,
      color: palette.primary.onPrimary,
      border: 'none',
      ':focus': {
        backgroundColor: palette.primary.main,
        color: palette.primary.onPrimary
      }
    },
    root: {
      ':hover': {
        backgroundColor: palette.secondary.main,
        color: palette.secondary.onSecondary
      },
      '&.Mui-selected': {
        backgroundColor: palette.primary.main,
        color: palette.primary.onPrimary
      }
    }
  }
}
const MuiPopperPaper = {
  styleOverrides: {
    paper: {
      backgroundColor: palette.surfaceContainerLow.main,
      color: palette.text.main,
    }
  }
}
const MuiListItem = {
  styleOverrides: {
    root: {

    }
  }
}

  
const theme = createTheme({
  colors: {
    text: '#1D1B20',
    backgroundDisabled: '#EBE7E7',
    colorEBF9FF: '#A4F4EC',
    colorB3261E: '#E4252E',
    colorFEF7FF: '#A4F4EC',
    colorB33F5B: '#E3CFFC'
  },
  palette,
  typography: {
    allVariants: { fontFamily: 'Inter' },
  },
  components: {
    MuiTab: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            color: palette.primary.main
          },
          color: palette.onSurfaceVariant.secondary,
          'MuiTabs-indicator': {
            backgroundColor: palette.primary.main
          }
        }
      }
    },
    MuiBadge: {
      styleOverrides: {
        badge: {
          backgroundColor: palette.tertiary.main,
          color: palette.tertiary.onTertiary
        }
      }
    },
    MuiPickersDay: MuiPickersDay,
    MuiAvatar: {
      styleOverrides: {
        colorDefault: {
          backgroundColor: palette.primary.main,
        },
        root: {
          color: `${palette.primary.onPrimary} !important`,
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: palette.surfaceContainerHighest.main,
            color: palette.text.main
          },
          ':hover': {
            backgroundColor: palette.onSurfaceTransparent.main,
            color: palette.text.main
          }
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        '&.Mui-disabled': {
          opacity: 1,
          backgroundColor: palette.surfaceContainerHighest.main,
        },
        deleteIcon: {
          color: palette.onSurfaceVariant.main,
        }
      }
    },
    MuiListItem,
    MuiPopper: MuiPopperPaper,
    MuiListItemButton: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: palette.secondary.main,
            color: palette.secondary.onSecondary
          }
        }
      }
    }
  }
})

export default theme;